import { IStateSelectorModel } from '~/models/components/StateSelector'
export default (): IStateSelectorModel => ({
  states: [],
})
